import { defineAction } from '~/prix'
import { z } from 'zod'
import semenProgramDeleteAction from './semenProgramDelete.action.json' with { type: 'json' }
import { semenProgramObject } from '../semenProgramObject'

const semenProgramDeleteDefinition = defineAction({
  ...semenProgramDeleteAction,

  input: z.object({ id: semenProgramObject.shape.id }),
  output: z.object({}),
})

export default semenProgramDeleteDefinition
